"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseStates = void 0;
var CaseStates;
(function (CaseStates) {
    CaseStates["ProcessStarted"] = "PROCESSSTARTED";
    CaseStates["ProcessFinalized"] = "PROCESSFINALIZED";
    CaseStates["ProcessCancelled"] = "PROCESSCANCELLED";
    CaseStates["ProcessAborted"] = "PROCESSABORTED";
    CaseStates["WaitForAccountCreation"] = "WAITFORACCOUNTCREATION";
    CaseStates["WaitForCallback"] = "WAITFORCALLBACK";
    CaseStates["CallbackFailed"] = "CALLBACKFAILED";
    CaseStates["WaitForDataCollection"] = "WAITFORDATACOLLECTION";
    CaseStates["DataCollectionFailed"] = "DATACOLLECTIONFAILED";
    CaseStates["WaitForQuotation"] = "WAITFORQUOTATION";
    CaseStates["WaitForQuotationApproval"] = "WAITFORQUOTATIONAPPROVAL";
    CaseStates["QuotationRejected"] = "QUOTATIONREJECTED";
    CaseStates["WaitForCooldown"] = "WAITFORCOOLDOWN";
    CaseStates["WaitForInstallation"] = "WAITFORINSTALLATION";
    CaseStates["WaitForFulfilment"] = "WAITFORFULFILMENT";
    CaseStates["WaitForLeaseQuotation"] = "WAITFORLEASEQUOTATION";
    CaseStates["WaitForLeaseQuotationApproval"] = "WAITFORLEASEAPPROVAL";
    CaseStates["WaitForDriverQuotation"] = "WAITFORDRIVERQUOTATION";
    CaseStates["WaitForDriverApproval"] = "WAITFORDRIVERAPPROVAL";
    CaseStates["QuotationVerification"] = "QUOTATIONVERIFICATION";
})(CaseStates || (exports.CaseStates = CaseStates = {}));
